export enum MARGIN_MODAL_WIDGET_TYPES {
  BORROW = 'borrow',
  REPAY = 'repay',
}
